/** Loading skeletons (shadcn Skeleton, RM-117). */
import { Skeleton } from './ui/skeleton'

/** Matches the JobsTable layout (RM-118): toolbar + bordered rows. */
export function JobListSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="space-y-3 skeleton-delayed">
      {/* Toolbar (count + Kolumny) */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-8 w-24" />
      </div>
      {/* Table */}
      <div className="overflow-hidden rounded-xl border border-border">
        {/* Header row */}
        <div className="flex items-center gap-4 border-b border-border bg-card px-4 py-3">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 flex-1" />
          <Skeleton className="h-4 w-28" />
        </div>
        {/* Body rows */}
        {Array.from({ length: count }, (_, i) => (
          <div
            key={i}
            className="flex items-center gap-4 border-b border-border px-4 py-3 last:border-0"
          >
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-5 w-16 rounded-full" />
            <Skeleton className="h-5 w-20 rounded-full" />
            <Skeleton className="h-4 flex-1" />
            <Skeleton className="h-4 w-28" />
          </div>
        ))}
      </div>
    </div>
  )
}

export function JobDetailSkeleton() {
  return (
    <div className="space-y-4 skeleton-delayed">
      <Skeleton className="h-6 w-1/4" />
      <Skeleton className="h-5 w-20 rounded-full" />
      <div className="grid grid-cols-2 gap-4 mt-4">
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i}>
            <Skeleton className="h-3 w-16 mb-1" />
            <Skeleton className="h-4 w-24" />
          </div>
        ))}
      </div>
    </div>
  )
}
